module.exports = __webpack_public_path__ + "static/media/blog2.2535561c.png";